import { React } from '@digsup/core-ui';
import { Icon } from '@digsup/components-icon';
import { Text } from '@digsup/components-text';
import { Image } from '@digsup/components-image';

import { FeaturesItem } from './FeaturesItem';
import privacyImg from './assets/privacy.png';
import privacy2xImg from './assets/privacy@2x.png';
import privacy3xImg from './assets/privacy@3x.png';

export const FeaturePrivacy = () => (
  <FeaturesItem
    title="Privacy in Mind"
    description="Things we do to keep user info secure. Privacy focused 
        features like not revealing your name to others until 
        you're ready to do so + clear alerts for what you're 
        sharing"
    icon={
      <Icon
        name="shield"
        size="xlarge"
        shape="round"
        fill="warm-accent"
        shapeColor="highlight-neutral"
      />
    }
    media={
      <div className="l-homepage-features__privacy-media">
        <div className="l-homepage-features__privacy-media-img">
          <Image
            src={privacyImg}
            srcset={`
              ${privacyImg} 468w,
              ${privacy2xImg} 936w,
              ${privacy3xImg} 1404w,
            `}
            sizes="468px"
            placeholderImage=""
            alt="Privacy focused features"
          />
        </div>
        <Text
          color="theme-white"
          align="center"
          size="6xs"
          className="l-homepage-features__privacy-media-caption u-padding-right-xxlarge u-padding-left-xxlarge">
          *By choosing to reply to this message, your DigsUp profile will become
          visible to the sender, including your profile image and blurb. In
          return, you will also be able to see the claimed address of the
          Sender.
        </Text>
      </div>
    }
  />
);
